if (!customElements.get("quick-view-modal")) {
    customElements.define(
      "quick-view-modal",
      class QuickViewModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector("#QuickViewModal");

          this.addEventListener("product-info:loaded", ({ target }) => {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          });
        }

        hide(preventFocus = false) {
          const cartNotification = document.querySelector("cart-drawer");
          if (cartNotification)
            cartNotification.setActiveElement(this.openedBy);
          // gg-perf (AC-2.4): keep the rendered popup so reopening the same product shows it at once; ModalDialog.hide pauses its media

          if (preventFocus) this.openedBy = null;
          super.hide();
        }

        show(opener) {
          // gg-perf (AC-2.4): reopening the product shown last reuses its rendered popup instead of rebuilding it
          const productUrl = opener.getAttribute("data-product-url").split("?")[0];
          if (!this.ggSubmitWatch) {
            this.ggSubmitWatch = true;
            // after an add to cart from the popup, the next open renders it fresh (quantity and options reset, as before)
            this.addEventListener("submit", () => { this.ggShownUrl = null; }, true);
          }
          if (this.ggShownUrl === productUrl && this.modalContent.querySelector("product-info")) {
            super.show(opener);
            return;
          }
          this.ggShownUrl = null;
          // gg-perf (FR-3): open immediately with a loading state; the popup loader fetches only the product section
          const token = (this.ggToken = (this.ggToken || 0) + 1);
          opener.setAttribute("aria-disabled", true);
          opener.classList.add("loading");
          opener.querySelector(".loading__spinner")?.classList.remove("hidden");
          this.modalContent.innerHTML = window.ggProductPopup.loadingMarkup();
          super.show(opener);

          window.ggProductPopup
            .load("quick_view", opener.getAttribute("data-product-url"), opener.dataset.templateSuffix)
            .then((responseText) => {
              if (token !== this.ggToken || !this.hasAttribute("open")) return;
              const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
              const productElement = responseHTML.querySelector("product-info");
              if (!productElement) throw new Error("product-info missing");

              this.preprocessHTML(productElement);
              HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

              // Ensure CompareColor component is defined when content is injected
              if (typeof window.compareColor === 'undefined' && !customElements.get('compare-color')) {
                try { window.compareColor(); } catch (e) { /* no-op */ }
              }
              if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
              if (window.ProductModel) window.ProductModel.loadShopifyXR();
              if (window.ggReapplyPriceLock) window.ggReapplyPriceLock();
              this.ggShownUrl = productUrl;
              // gg-perf: move focus in once the content has painted; focusing at once forced a full layout first (0.3 s on phones)
              requestAnimationFrame(() => requestAnimationFrame(() => {
                if (token !== this.ggToken || !this.hasAttribute("open") || typeof trapFocus !== "function") return;
                trapFocus(this.querySelector(".drawer__inner, .popup__inner"), this.querySelector('[role="dialog"], .popup__inner'));
              }));
            })
            .catch(() => {
              if (token !== this.ggToken || !this.hasAttribute("open")) return;
              this.modalContent.innerHTML = window.ggProductPopup.errorMarkup(opener.getAttribute("data-product-url"));
            })
            .finally(() => {
              opener.removeAttribute("aria-disabled");
              opener.classList.remove("loading");
              opener.querySelector(".loading__spinner")?.classList.add("hidden");
            });
        }

        preprocessHTML(productElement) {
          productElement.classList.forEach((classApplied) => {
            if (
              classApplied.startsWith("color-") ||
              classApplied === "gradient"
            )
              this.modalContent.classList.add(classApplied);
          });
          this.preventDuplicatedIDs(productElement);
          this.removeDOMElements(productElement);
          this.removeGalleryListSemantic(productElement);
          this.preventVariantURLSwitching(productElement);
        }

        preventVariantURLSwitching(productElement) {
          productElement.setAttribute("data-update-url", "false");
        }

        removeDOMElements(productElement) {
          const pickupAvailability = productElement.querySelector(
            "pickup-availability"
          );
          if (pickupAvailability) pickupAvailability.remove();

          const shareButton = productElement.querySelector("share-button");
          if (shareButton) shareButton.remove();

          const productModal = productElement.querySelector("product-modal");
          if (productModal) productModal.remove();

          const modalDialog = productElement.querySelectorAll("modal-dialog");
          if (modalDialog) modalDialog.forEach((modal) => modal.remove());

          const sideDrawerOpener = productElement.querySelectorAll(
            "side-drawer-opener:not(.agree-condition-popup-modal__opener--keep)"
          );
          if (sideDrawerOpener)
            sideDrawerOpener.forEach((button) => button.remove());

          const sideDrawer = productElement.querySelectorAll(
            "side-drawer:not(.agree-condition-popup-modal__drawer--keep)"
          );
          if (sideDrawer) sideDrawer.forEach((drawer) => drawer.remove());
        }

        preventDuplicatedIDs(productElement) {
          const sectionId = productElement.dataset.section;

          const oldId = sectionId;
          const newId = `quickview-${sectionId}`;

          productElement.innerHTML = productElement.innerHTML.replaceAll(
            oldId,
            newId
          );
          Array.from(productElement.attributes).forEach((attribute) => {
            if (attribute.value.includes(oldId)) {
              productElement.setAttribute(
                attribute.name,
                attribute.value.replace(oldId, newId)
              );
            }
          });

          productElement.dataset.originalSection = sectionId;
        }

        removeGalleryListSemantic(productElement) {
          const galleryList = productElement.querySelector(
            '[id^="Slider-Gallery"]'
          );
          if (!galleryList) return;

          galleryList.setAttribute("role", "presentation");
          galleryList
            .querySelectorAll('[id^="Slide-"]')
            .forEach((li) => li.setAttribute("role", "presentation"));
        }
      }
    );
}
